import { motion } from "framer-motion";
import { Mail, Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/data";
import { fadeUp, stagger, viewport } from "@/lib/motion";

export default function Contact() {
  const cards = [
    { icon: Mail, label: "E-posta", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: Phone, label: "Telefon", value: CONTACT.phone, href: `tel:${CONTACT.phone.replace(/\s/g, "")}` },
    { icon: MessageCircle, label: "WhatsApp", value: CONTACT.phone, href: `https://wa.me/${CONTACT.whatsapp}` },
  ];
  return (
    <section id="iletisim" data-testid="contact-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <span className="text-sm uppercase tracking-[0.2em] text-[#1B19A8] font-semibold">İletişim</span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#1a1a1a] mt-4 leading-tight">
            Sorularını <span className="text-[#1B19A8]">bize sor.</span>
          </h2>
        </div>
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="grid sm:grid-cols-3 gap-5">
          {cards.map((c, i) => (
            <motion.a
              key={c.label}
              href={c.href}
              target={c.label === "WhatsApp" ? "_blank" : undefined}
              rel="noopener noreferrer"
              variants={fadeUp}
              custom={i}
              whileHover={{ y: -4 }}
              data-testid={`contact-${c.label.toLowerCase()}`}
              className="group rounded-3xl bg-white border border-black/5 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.04)] hover:border-[#1B19A8]/25 transition-colors"
            >
              <span className="grid place-items-center w-12 h-12 rounded-2xl bg-[#1B19A8]/8 text-[#1B19A8] mb-5 group-hover:bg-[#1B19A8] group-hover:text-white transition-colors">
                <c.icon size={24} strokeWidth={2} />
              </span>
              <div className="text-xs uppercase tracking-[0.15em] text-[#1a1a1a]/50 font-semibold mb-1">{c.label}</div>
              <div className="font-display text-lg font-bold text-[#1a1a1a]">{c.value}</div>
            </motion.a>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
